import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './framework/router'
import store from './framework/store'
import i18n from './i18n'
import './framework/style/index.scss'

const app = createApp(App)

// 注册Element Plus Icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册Element Plus
const locale = localStorage.getItem('locale') || 'zh-CN'
app.use(ElementPlus, { locale: locale === 'zh-CN' ? zhCn : en })

app.use(store)
app.use(router)
app.use(i18n)

app.mount('#app')
